export enum ResearchCategory {
    Research = "Research"
}

export enum ResearchEmailType {
    performanceAwaitingApproval = 0,
    performanceApproved = 1,
    performancePaymentAdded = 2,
    performancePaymentConfirmed = 3,
    performanceFileUploaded = 4,
    performanceSubmissionCompleted = 5,
    performanceReviewSubmitted = 6
}

export enum ResearchStatus {
    ScriptReviewRequired = 'Script Review Required',
    SubmissionFailed = 'Submission Failed',

    // Cannot submit without uploaded file / url
    PendingCoordinatorApproval = 'Pending Coordinator Approval',
    PendingPayment = 'Pending Payment',
    PendingDocument = 'Pending Document',
    PendingReview = 'Pending Review',
    SubmissionCompleted = 'Submission Completed'
}
